import { Link } from 'react-router-dom';

const AdminPanel = () => {
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>Admin Panel</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Admin Panel </h2>
				<div className="divider" />
				<ul className="text-lg menu">
					<li className="hidden">
						<Link className="link" to="/admin-panel">
							User & Organization Management
						</Link>
					</li>
					<li className="hidden">
						<Link className="link" to="/admin-panel">
							Agency Configuration
						</Link>
					</li>
					<li className="hidden">
						<Link className="link" to="/admin-panel">
							Program Configuration
						</Link>
					</li>
					<li>
						<Link className="link" to="/admin-panel/elig-enroll">
							Eligible Enrollees
						</Link>
					</li>
					<li>
						<Link className="link" to="/admin-panel/cred-cbos">
							Credentialed Billing Service Providers (CBOs)
						</Link>
					</li>
					<li>
						<Link className="link" to="/admin-panel/ilos-completed">
							Completed Billing Line Items
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
};

export default AdminPanel;
